/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Extraction_RevisionInputs */

const en_inbound_field_extraction_revision = /** @type {(inputs: Inbound_Field_Extraction_RevisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request to the extraction tool`)
};

/**
* | output |
* | --- |
* | "Request to the extraction tool" |
*
* @param {Inbound_Field_Extraction_RevisionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_extraction_revision = /** @type {((inputs?: Inbound_Field_Extraction_RevisionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Extraction_RevisionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_extraction_revision(inputs)
});